import {Iitem} from 'core/main/Interface';
import {OPTION_TYPE} from "core/config/constants";

class Params {

	private static menus: any;
	private static items: any;
	private static item_sort: any;
	private static item_metadata: any;
	private static item_data: any;

	private static targets: any;
	private static hitpoints: any;
	private static codes: any;
	private static neighbors: any;
	private static playhouse_panels: any[];


	static add = (data): void => {

		Params.menus = data.menus;
		Params.items = data.items;
		Params.item_metadata = data.item_metadata;
		Params.item_data = data.item_data;

		Params.targets = data.targets;
		Params.hitpoints = data.hitpoints;
		Params.codes = data.codes;
		Params.neighbors = data.neighbors;
		Params.playhouse_panels = data.playhouse_panels;

	};

	static getItem = (itemId: number): Iitem => {

		return Params.items[itemId];

	};


	static getItemData = (itemId: number): any => {

		return Params.item_data[itemId];

	};


	static getItemsByType = (item_type: string | string[]): {} => {

		let result: any = {};

		if (typeof item_type === 'string') {
			item_type = [item_type];
		}

		$.each(Params.items, function (i: number, row) {

			if (item_type.indexOf(row.item_type) != -1) {

				result[i] = row;
			}
		});

		return result;
	};

	static getPlayhousePanels = (parent_id: number, color: OPTION_TYPE.TRIM_COLOR, level: number): any[] => {

		return Params.playhouse_panels[parent_id][color][level];

	};


	static getTargets = (itemId: number): any[] => {

		return Params.targets[itemId];

	};


	static getMenus = (): any[] => {

		return Params.menus.menu;

	};

	static getItemSort = (): any[] => {

		if (Params.item_metadata.item_sort)
			return Params.item_metadata.item_sort;

	};

	static getNeedsBrace = (): any[] => {

		if (Params.item_metadata.needs_brace)
			return Params.item_metadata.needs_brace;

	};

	static getMenuItems = (): any[] => {

		return Params.menus.menu_items;

	};


	static getMenuItemsFor = (menuId: number): any[] => {

		let result: any[] = [];

		$.each(Params.menus.menu_items, function (i: number, row) {

			if (row.menu_key == menuId) {

				result.push(row);
			}
		});

		return result;

	};

	static getHitpoints = (itemId: number): string[] => {

		return Params.hitpoints[itemId];

	};


	static getHitpointByType = (itemId: number, prefix: string): string[] => {

		let result: any[] = [];

		for (let key in Params.hitpoints[itemId]) {
			if (key.substring(0, 1) == prefix) {

				result.push(key);
			}
		}
		return result;
	};


	static getHitpoint = (itemId: number, hitpoint: string): string[] => {

		return Params.hitpoints[itemId][hitpoint];

	};

	static getCodes = (itemId: number): {} => {

		let result: any = (Params.codes[itemId] == undefined) ? '{}' : Params.codes[itemId];

		if (typeof result === 'string') {
			result = JSON.parse(result);
		}
		return result;
	};


	static getNeighborAllow = (itemId: number): number[] => {

		return (Params.neighbors[itemId]) ? Params.neighbors[itemId] : [];

	};
}

export {Params};

